// AdminAssignFormPage.jsx

import React, { useState, useEffect } from 'react';
import API from '../services/api'; // If you have a custom Axios instance

function AdminAssignFormPage() {
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState('');
  const [formName, setFormName] = useState('');
  const [formPath, setFormPath] = useState('');
  const [formLink, setFormLink] = useState('');

  useEffect(() => {
    fetchClients();
  }, []);

  // Fetch all active clients for the dropdown
  const fetchClients = async () => {
    try {
      const res = await API.get('/admin/all-clients');
      setClients(res.data);
    } catch (error) {
      console.error(error);
      alert('Error fetching clients');
    }
  };

  // Handler to assign the form
  const handleAssignForm = async () => {
    try {
      const body = {
        clientId: selectedClientId,
        formName,
        formPath
      };

      // Perform the POST request
      const response = await fetch('http://localhost:4000/api/forms/assign', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await response.json();

      // Check the response object
      if (data.formId) {
        setFormLink(data.link);
        alert(`Form assigned successfully. Link: ${data.link}`);
      } else {
        alert(data.error || 'Error assigning form');
      }
    } catch (err) {
      console.error(err);
      alert('Error assigning form');
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Assign Form to Client</h1>

      {/* Client dropdown */}
      <div style={{ marginBottom: '1rem' }}>
        <label>Client: </label>
        <select
          value={selectedClientId}
          onChange={(e) => setSelectedClientId(e.target.value)}
        >
          <option value="">-- Choose Client --</option>
          {clients.map((client) => (
            <option key={client.id} value={client.id}>
              {client.client_name}
            </option>
          ))}
        </select>
      </div>

      {/* Form name */}
      <div style={{ marginBottom: '1rem' }}>
        <label>Form Name: </label>
        <input
          type="text"
          value={formName}
          onChange={(e) => setFormName(e.target.value)}
          placeholder="e.g. Consent Form"
        />
      </div>

      {/* Form path */}
      <div style={{ marginBottom: '1rem' }}>
        <label>Form Path: </label>
        <input
          type="text"
          value={formPath}
          onChange={(e) => setFormPath(e.target.value)}
          placeholder="/forms/consent.pdf"
        />
      </div>

      <button
        onClick={handleAssignForm}
        disabled={!selectedClientId || !formName || !formPath}
      >
        Assign Form
      </button>

      {/* Show the assigned form link, if any */}
      {formLink && (
        <div style={{ marginTop: '20px' }}>
          <p>Form assigned successfully!</p>
          <a href={formLink} target="_blank" rel="noreferrer">
            {formLink}
          </a>
        </div>
      )}
    </div>
  );
}

export default AdminAssignFormPage;
